<template>
  <card>
    <div class="flex items-center justify-center pb-8 w-full font-bold text-xl">
      <router-link :to="link">{{ post.title }}</router-link>
    </div>
    {{ post.categories }}
    <div
      class="pt-8 text-xs text-gray-600 flex justify-end"
    >{{ post.createdAt | dateFormat("DD-MM-YYYY hh:mm") }}</div>
  </card>
</template>

<script>
import Card from "@/components/Card";
export default {
  name: "Cards-Blog-Post",
  props: ["post"],
  components: { Card },
  computed: {
    link: function() {
      return { name: "Blog.Read", params: { slug: this.post.slug } };
    }
  }
};
</script>
